export const richDetailsStateClosedClass = 'rd-closed';
export const richDetailsStateOpenClass = 'rd-open';
